import { t } from 'i18next';
import * as yup from 'yup';

export const siteSchema = yup.object().shape({
  pathSegment: yup
    .string()
    .required(t('site.general.sitePathRequired'))
    .matches(/^[a-zA-Z0-9-_]+$/, t('site.general.sitePathInvalid')),
  authenticationConnectionId: yup.string().optional(),
  wicketAuthEnabled: yup.boolean().optional(),
  requirePersonNames: yup.boolean().optional(),
  design: yup
    .object({
      introduction: yup
        .object({
          enabled: yup.boolean().optional(),
          html: yup.string().optional(),
        })
        .optional(),
      campaignPageTitle: yup.string().optional(),
      campaignPageDescriptionHtml: yup.string().optional(),
      largeLogoImageId: yup.string().nullable().optional(),
      largeLogoImageUrl: yup.string().optional(),
      smallLogoImageId: yup.string().nullable().optional(),
      smallLogoImageUrl: yup.string().optional(),
      backgroundImageId: yup.string().nullable().optional(),
      backgroundImageUrl: yup.string().optional(),
      useWicketFooter: yup.boolean().optional(),
      footerHtml: yup.string().optional(),
      privacyPolicyHtml: yup.string().optional(),
      privacyPolicyAgreementText: yup.string().optional(),
      styleSheet: yup.string().optional(),
    })
    .optional(),
});

export type SiteFormValues = yup.InferType<typeof siteSchema>;
